import React from 'react'
import CameraIcon from '../../elements/icons/CameraIcon'
import ApplicationStatus from '../../elements/ApplicationStatus'
import { calculateAge, transactionTimeStamp } from '../../../utils'
import { Link } from 'react-router-dom'
import ArrowIcon from '../../elements/icons/ArrowIcon'

const ApplicationCard = ({application}) => {
  return (
    <div className='w-full relative'>
        <div className='bg-gray-50 h-[250px] rounded-[8px] flex items-center justify-center' style={{
          backgroundImage: `url(" ${application.passportPhotograph} ")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'none'
        }}>
            {(!application.passportPhotograph || application.passportPhotograph === '') &&
                <CameraIcon className={`w-8 h-8 text-gray-400`} />
            }
        </div>
        <div className='px-4 py-2'>
            <p className='uppercase tracking-[0.2em] text-sm'>{`${application.firstName}${application.otherNames ? ` ${application.otherNames} ` : ' '}${application.lastName}`}</p>
            <div className='flex items-center justify-between'>
              <p className='text-sm mt-2 mb-2'>{calculateAge(application?.dob)} year old {application?.gender?.toLowerCase()}</p>
              <ApplicationStatus status={application.status} />
            </div>
            <p className='capitalize text-sm mt-2 mb-2'>Applied for {application?.admission?.title || ''} into {application.class}</p>
            <p className='capitalize text-sm mt-2 mb-2'>Date applied: {transactionTimeStamp(application.createdAt).date}</p>

            {!application.completed ?
              <>
                <p className='text-gray-300 text-xs mb-1'>Application Incomplete</p>
                {/* <Link to={`/user/applications/new-application/${application.admission._id}?application=${application._id}`}>
                    <button className='text-sm flex flex-row items-center gap-x-3 mt-5 text-red-800 hover:text-gray-400 transition duration-200'>Continue application <ArrowIcon className={`w-5 h-5`} /></button> 
                </Link> */}
              </>
              :
              <Link to={`${application._id}`}>
                  <button className='text-sm flex flex-row items-center gap-x-3 mt-5 text-vcm-purple hover:text-gray-400 transition duration-200'>See application details <ArrowIcon className={`w-5 h-5`} /></button> 
              </Link>
            }

        </div>
    </div>
  )
}

export default ApplicationCard